import React from 'react'
import { Link } from 'react-router-dom'

const Pricing = () => {
  const styleObj = {
    verticalAlign: 'middle'
  }
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>zoomback Free</th>
            <th>zoomback Freelance</th>
            <th>zoomback Company</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>For who</td>
            <td>Everyone</td>
            <td>Freelancers</td>
            <td>Businesses</td>
          </tr>
          <tr>
            <td>Watermark-free</td>
            <td><i className="fas fa-times"></i></td>
            <td><i className="fas fa-check"></i></td>
            <td><i className="fas fa-check"></i></td>
          </tr>
          <tr>
            <td>Shareable template</td>
            <td><i className="fas fa-times"></i></td>
            <td><i className="fas fa-times"></i></td>
            <td><i className="fas fa-check"></i></td>
          </tr>
          <tr>
            <td>But why</td>
            <td>An accessible solution for people who aren&apos;t fussed about the (nicely designed) logo watermark.</td>
            <td>A professional option for a remote working professional. The only logo within sight is your own.</td>
            <td>Brand image is important. This scalable solution equips brand representatives on zoom, easily.</td>
          </tr>
          <tr>
            <td>Dummy-proof instructions</td>
            <td>Fill in your details, adjust the colors, and then click: <br/><br/>Export Free</td>
            <td>Same.<br/>But you should click: <br/><br/>Checkout $5</td>
            <td>Same.<br/>But you should click: <br/><br/>Checkout $10</td>
          </tr>
          <tr>
            <td>What does the button do?</td>
            <td>Triggers the virtual background to download to your computer.<br/><br/>Automagically.</td>
            <td>Redirects to checkout. After payment success, you&apos;ll be redirected to download your delicious design.</td>
            <td>Same. But you&apos;ll be redirected to a shareable template. Share it with ∞ colleagues, who&apos;ll simply fill in their details and then export.</td>
          </tr>
          <tr>
            <td>Price</td>
            <td>Free</td>
            <td>$5</td>
            <td>$10</td>
          </tr>
        </tbody>
      </table>
      <br/><br/>
      <Link to="/create">Create your zoomback <i style={styleObj} className="fas fa-arrow-right"></i></Link>
    </div>
  )
}

export default Pricing
